export default __webpack_public_path__ + "video/3_construct_strategic_defense.mp4";